export interface SpecialItem {
  id: string;
  title: string;
  subtitle: string;
  intro: string;
  cover: string;
  month: string;
  titleIds: string[];
  reasons: string[];
}

export const specials: SpecialItem[] = [
  {
    id: "midnight-suspense",
    title: "午夜悬疑档案",
    subtitle: "当真相被藏进黑暗里",
    intro:
      "从深海到雨夜，从法庭到镜面，悬疑从不只是“谁是凶手”。这个专题挑选了六部把悬念建立在人性缝隙里的作品，适合关掉灯，一次看完。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20key%20art%20of%20a%20long%20corridor%20with%20a%20single%20open%20door%20spilling%20cold%20blue%20light%2C%20fog%20on%20the%20floor%2C%20deep%20navy%20palette%2C%20no%20text%2C%20mysterious%20atmosphere&width=1200&height=675&seq=sp-01&orientation=landscape",
    month: "十月专题",
    titleIds: ["deep-sea-echo", "long-night-coming", "the-man-in-the-mirror", "silent-testimony", "dark-river-trail", "foggy-capital-files"],
    reasons: [
      "六部作品都不约而同地把“解释”留到了最后，但真正让人记住的不是答案，而是每个人在答案面前的选择。",
      "如果你只有一晚上的时间，建议从《长夜将至》开始，用《深海回声》收尾。前者的雨会让你警觉，后者的静会让你失眠。",
    ],
  },
  {
    id: "long-night-harbor",
    title: "长夜与旧港",
    subtitle: "年代质感里的中国故事",
    intro:
      "雾、渡口、老楼梯、一间开了四十年的面馆。这个专题收录了五部带着湿润空气的作品，它们把镜头对准普通人的一生，也把时间留在了画面里。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20period%20key%20art%20of%20an%20old%20southern%20Chinese%20harbor%20town%20at%20blue%20hour%20with%20wooden%20boats%2C%20stone%20stairs%20and%20warm%20lit%20windows%20in%20thick%20mist%2C%20no%20text%2C%20painterly&width=1200&height=675&seq=sp-02&orientation=landscape",
    month: "年代专题",
    titleIds: ["harbor-in-fog", "old-days-in-the-hill-city", "ferry-of-long-wind", "above-the-snowline", "summer-screening-room"],
    reasons: [
      "这一组作品的共同点是“慢”。它们不急着推进情节，而是让你先在环境里待一会儿，再慢慢认识里面的人。",
      "建议按《雾港往事》→《长风渡口》→《山城旧事》的顺序观看，你会发现三代人的迁徙其实是一条线。",
    ],
  },
  {
    id: "beyond-the-stars",
    title: "越过星尘",
    subtitle: "科幻的另一种写法",
    intro:
      "太空不只有爆炸和跃迁。这个专题里的五部作品更愿意讨论距离：光年的距离、消息延迟的距离，以及两个人在同一间房里却无法沟通的距离。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20science%20fiction%20key%20art%20of%20a%20tiny%20space%20station%20window%20framing%20a%20vast%20star%20field%20and%20a%20distant%20blue%20planet%2C%20deep%20navy%20and%20soft%20cyan%20tones%2C%20no%20text%2C%20elegant&width=1200&height=675&seq=sp-03&orientation=landscape",
    month: "科幻专题",
    titleIds: ["stardust-traveler", "interstellar-outpost", "letter-beyond-lightyear", "beyond-the-dunes", "night-of-mountains-and-seas"],
    reasons: [
      "从硬核到柔软，这五部作品展示了科幻的两种极端：一种把宇宙拍得很大，一种把宇宙拍得很小，小到只剩一通无法接通的电话。",
      "如果时间有限，先看《光年之外的信》。它只有一百一十五分钟，却把“延迟”这个概念拍成了可以被感受到的东西。",
    ],
  },
  {
    id: "city-and-youth",
    title: "城市与少年",
    subtitle: "在深夜的城市里继续奔跑",
    intro:
      "夏天、天台、旧影院、一条海岸公路。四部关于年轻人的作品，没有说教，也没有奇迹，只是认真地记录了那些想要被看见的时刻。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20key%20art%20of%20teenagers%20sitting%20on%20a%20rooftop%20edge%20above%20a%20glowing%20city%20at%20dusk%2C%20bicycles%20nearby%2C%20amber%20sunset%20fading%20into%20deep%20blue%20sky%2C%20no%20text%2C%20nostalgic&width=1200&height=675&seq=sp-04&orientation=landscape",
    month: "青春专题",
    titleIds: ["chasing-the-wind", "city-glimmer", "summer-screening-room", "letters-in-april", "twenty-four-hour-er"],
    reasons: [
      "这几部作品的共同气质是“不着急长大”。它们允许角色犯错，也允许故事停在一个没有结论的夏天。",
      "推荐在周末的下午连着看《夏日放映厅》和《追风少年》，前者关于告别，后者关于出发。",
    ],
  },
];

export interface HeroSlide {
  id: string;
  kicker: string;
  title: string;
  subtitle: string;
  meta: string;
  image: string;
  link: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-1",
    kicker: "本周焦点 · 电影",
    title: "深海回声",
    subtitle: "一段来自万米海沟的低频回声，正在改写二十年前的失踪记录。",
    meta: "2024 · 中国大陆 · 悬疑 / 剧情 · 8.7 分",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20deep%20ocean%20trench%20with%20a%20single%20submersible%20light%20cutting%20through%20immense%20darkness%2C%20drifting%20particles%20and%20faint%20blue%20glow%2C%20moody%20navy%20palette%2C%20no%20text%2C%20epic%20film%20key%20art&width=1920&height=1080&seq=hero-01&orientation=landscape",
    link: "/detail/deep-sea-echo",
  },
  {
    id: "hero-2",
    kicker: "年度剧王 · 电视剧",
    title: "暗河迷踪",
    subtitle: "城市地下暗河连续三年异常，刑警与地质学者一起走进那条不该存在的水道。",
    meta: "2024 · 全 24 集 · 悬疑 / 犯罪 · 8.9 分",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20wide%20shot%20of%20an%20underground%20brick%20water%20tunnel%20lit%20by%20a%20single%20flashlight%20beam%20with%20mist%20over%20dark%20water%2C%20deep%20navy%20and%20rust%20tones%2C%20no%20text%2C%20cinematic%20still&width=1920&height=1080&seq=hero-02&orientation=landscape",
    link: "/detail/dark-river-trail",
  },
  {
    id: "hero-3",
    kicker: "专题策划 · 越过星尘",
    title: "科幻的另一种写法",
    subtitle: "不只有爆炸和跃迁。五部作品，把宇宙拍成了可以被听见的距离。",
    meta: "专题 · 5 部作品 · 编辑推荐",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20science%20fiction%20wide%20artwork%20of%20a%20vast%20star%20field%20with%20a%20thin%20arc%20of%20a%20blue%20planet%20and%20small%20spaceship%20silhouette%2C%20deep%20navy%20and%20cyan%20gradient%2C%20no%20text%2C%20premium%20poster%20style&width=1920&height=1080&seq=hero-03&orientation=landscape",
    link: "/special/beyond-the-stars",
  },
];